module.exports = __webpack_public_path__ + "img/top-category-other.f785389f.jpg";